/** @jsx jsx */
import { jsx } from '@emotion/react'
import { jornadaCompletaStyle } from '../assets/styles/JornadaCompleta.styles'
import { Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import EducacaoInfantilH from '../assets/images/LP-arabe/jornada/educacao-infantil-hover.svg'
import EducacaoInfantilA from '../assets/images/LP-arabe/jornada/educacao-infantil-active.svg'
import EnsinoFundamentalH from '../assets/images/LP-arabe/jornada/ensino-fundamental-hover.svg'
import EnsinoFundamentalA from '../assets/images/LP-arabe/jornada/ensino-fundamental-active.svg'

const JornadaCompleta = () => {
  useEffect(() => {
    const images = [
      EducacaoInfantilH,
      EducacaoInfantilA,
      EnsinoFundamentalH,
      EnsinoFundamentalA
    ]
    images.forEach(src => {
      const img = new Image()
      img.src = src
    })
  }, [])

  return (
    <section css={jornadaCompletaStyle}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={6} md={6} sm={12}>
            <h2>Da infância à vida acadêmica: <span>uma jornada completa</span></h2>
          </Col>
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <p>Nossa estrutura foi pensada para estimular a criatividade e o aprendizado das crianças, da Educação Infantil ao Fundamental Anos Iniciais.</p>
          </Col>
        </Row>

        <Row>
          <Col lg={6} md={6} sm={12}>
            <a href='/educacao-infantil' className='educacao-infantil' />
          </Col>
          <Col lg={6} md={6} sm={12}>
            <a href='/ensino-fundamental' className='ensino-fundamental' />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default JornadaCompleta
